import { StateDTO, City, CityDTO, CountryDTO } from '@/api/location/types';

type StateKey = string;

export const toStateKey = (country: string, state: string) => (
  JSON.stringify({ country, state })
);

export interface LocationState {
  delegate?: LocationDelegate;
  deferred: LocationDeferable;
  countryContext: string;
  stateContext: string;
  cityContext: string;
  statesOptions: StateDTO[];
  citiesOptions: City[];
  countries: string[];
  states: Map<string, CountryDTO>;
  cities: Map<StateKey, City[]>;
  status: string;
  cityFromCentroid: CityDTO | null;
  stateForCentroid: string;
}

export interface LocationDelegate {
  fetchStatesByCountry: (country: string) => Promise<any>;
  fetchCitiesByCountryAndState: (country: string, state: string) => Promise<any>;
}

export interface LocationDeferable {
  country?: string,
  state?: string;
  city?: City;
}
